import React from "react";

type Bitrix24InlineFormProps = {
  type: "consultation" | "contact";
};

export function Bitrix24InlineForm({ type }: Bitrix24InlineFormProps) {
  const consultation = type === "consultation";

  return (
    <iframe
      className="bitrix24-inline-form"
      src={`/bitrix24-inline.html?type=${type}`}
      title={
        consultation
          ? "Formularz bezpłatnej konsultacji Bitrix24"
          : "Formularz kontaktowy Bitrix24"
      }
      loading="eager"
    />
  );
}
